var _extends = require('babel-runtime/helpers/extends').default;

var _Object$assign = require('babel-runtime/core-js/object/assign').default;

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default').default;

(function () {
  Flint.file('views/main.js', function (require) {
    var _fastclick = require('fastclick');

    var _fastclick2 = _interopRequireDefault(_fastclick);

    Flint.staticStyles('Main', {
      '$': '#_flintapp .ViewMain',
      '$page': '#_flintapp page.Main, #_flintapp .Main.page, #_flintapp .ViewMain.page, #_flintapp .Main > .page'
    }, {
      '$': {
        width: '100%',
        minHeight: '100%',
        alignItems: 'center',
        overflowX: 'hidden'
      },
      '$page': {}
    });
    Flint.view('Main', function (view, on, $) {
      var MIN_DESKTOP_WIDTH = 680;
      var MAX_DESKTOP_WIDTH = 960;
      var DESKTOP_PADDING = 20;

      var getWidth = function getWidth() {
        var ret = Math.min(document.body.offsetWidth - DESKTOP_PADDING * 2, MAX_DESKTOP_WIDTH);
        if (ret < MIN_DESKTOP_WIDTH) {
          // It's gonna be mobile mode so take out the padding
          ret += DESKTOP_PADDING * 2;
        }
        return ret;
      };

      _Object$assign(M.context, {
        colors: atom(Record({
          // accent: 'rgb(255, 190, 49)'
          accent: 'rgb(215, 98, 124)',
          logoPrimary: 'rgb(155, 103, 113)',
          'default': '#666'
        })()),
        fonts: atom(Record({
          normal: null
        })()),
        width: atom(getWidth()),
        isMobile: derivation(function () {
          return M.context.width.get() < MIN_DESKTOP_WIDTH;
        }),
        viewportHeight: atom(document.body.offsetHeight),
        viewportWidth: atom(document.body.offsetWidth)
      });

      on.resize(window, function () {
        M.context.width.set(getWidth());
        M.context.viewportWidth.set(document.body.offsetWidth);
        M.context.viewportHeight.set(document.body.offsetHeight);
      });

      _fastclick2.default.attach(document.body);

      var mixpanelSuperProperties = derivation(function () {
        return IMap({
          isMobile: M.context.isMobile.get()
        });
      });
      mixpanelSuperProperties.react(function (mixpanelSuperProperties) {
        M.mixpanel.register(mixpanelSuperProperties.toJS());
      });

      var canonicalRoute = derivation(function () {
        return '/' + M.context.route.get().split('/').filter(function (pathPart) {
          return !!pathPart;
        }).join('/');
      });
      canonicalRoute.react(function (canonicalRoute) {
        if (canonicalRoute != M.context.route.get()) {
          history.replaceState({}, '', canonicalRoute);
        }
      });

      var isStaticRoute = derivation(function () {
        var staticRoutes = ['/', '/3sa', '/about', '/contact', '/enchant-mr-right', '/residential/men', '/residential/women', '/sandbox', '/terms'];
        return staticRoutes.indexOf(M.context.route.get()) >= 0;
      });view.render(function () {
        return view.el(
          ['page', 1],
          { ref: function () {
              // After the page renders, the scroll bar might appear and change the
              // offsetWidth without a resize event.
              M.context.width.set(getWidth());
            } },
          Flint.routeMatch('/') && view.el(['HomePage', 1], _extends({ route: '/' }, Flint.routeParams('/'))),
          Flint.routeMatch('/3sa') && view.el(['TsaPage', 1], _extends({ route: '/3sa' }, Flint.routeParams('/3sa'))),
          Flint.routeMatch('/enchant-mr-right') && view.el(['EmrPage', 1], _extends({ route: '/enchant-mr-right' }, Flint.routeParams('/enchant-mr-right'))),
          Flint.routeMatch('/residential/men') && view.el(['MensResiPage', 1], _extends({ route: '/residential/men' }, Flint.routeParams('/residential/men'))),
          Flint.routeMatch('/residential/women') && view.el(['WomensResiPage', 1], _extends({ route: '/residential/women' }, Flint.routeParams('/residential/women'))),
          Flint.routeMatch('/about') && view.el(['AboutPage', 1], _extends({ route: '/about' }, Flint.routeParams('/about'))),
          Flint.routeMatch('/contact') && view.el(['ContactPage', 1], _extends({ route: '/contact' }, Flint.routeParams('/contact'))),
          Flint.iff(!isStaticRoute.get()) && view.el(['NotFoundPage', 1], { if: !isStaticRoute.get() }),
          Flint.routeMatch('/terms') && view.el(['TermsPage', 1], _extends({ route: '/terms' }, Flint.routeParams('/terms'))),
          Flint.routeMatch('/sandbox') && view.el(['SandboxPage', 1], _extends({ route: '/sandbox' }, Flint.routeParams('/sandbox')))
        );
      });

      $["page"] = function (_, _index) {
        return {
          width: M.context.width.get() + 2 * DESKTOP_PADDING,
          padding: [0, DESKTOP_PADDING]
        };
      };
    });
  })
})();
//# sourceMappingURL=main.js.map
